const CONSTS_CONFIG = {
  CHIPTYPE: {
    ug: "USH",
    ke: "KSH",
    ng: "NGN",
    gh: "GHS",
    tz: "TZS"
  },
  EVENT_BUS: {
    BACK: "BACK_EVENT"
  },
  PARENT_CMD: {
    SUCCESS: "success",
    CANCEL: "cancel",
    ERROR: "error",
    FAILED: "failed",
    LIVECHAT: "livechat",
    PRELOAD:"preload",
    WHATSAPP: "whatsapp"
  },
  WhatsAppPhone: {
    ke: "2540711019120",
    ug: "2560708112111",
    gh: "2330201687746",
    ng: "23409069333333",
    tz: "255750178887"
  },
  liveHelp: {
    ke: "https://embed.tawk.to/592c03184374a471e7c50484/default",
    ug: "https://embed.tawk.to/5ab371fbd7591465c708ccd2/default",
    ng: "https://embed.tawk.to/5e8d9f0335bcbb0c9aaf02cf/default",
    in: "https://embed.tawk.to/592c03184374a471e7c50484/default",
    gh: "https://embed.tawk.to/5fd186cb920fc91564cf36ee/default",
    tz: "https://embed.tawk.to/5fd186cb920fc91564cf36ee/default"
  },
  All_PAYMODE: [
    {
      tabName: "Card",
      componentName: "BackCard",
      method: "backend",
      type: "card",
      selectName: "Pay with ATM Card",
      selectTitle: "Card",
      ico: "icon-Icon_Card_nor_48"
    },
    {
      tabName: "Card",
      componentName: "PaystackCard",
      method: "js",
      type: "card",
      selectName: "Pay with ATM Card",
      selectTitle: "Card",
      ico: "icon-Icon_Card_nor_48"
    },
    {
      tabName: "Card",
      componentName: "CartCont",
      method: "inline",
      type: "card",
      selectName: "Pay with ATM Card",
      selectTitle: "Card",
      ico: "icon-Icon_Card_nor_48"
    },
    {
      tabName: "Card",
      componentName: "CartCont",
      method: "standard",
      type: "card",
      selectName: "Pay with ATM Card",
      selectTitle: "Card",
      ico: "icon-Icon_Card_nor_48"
    },
    // bank
    {
      tabName: "Bank Acc.",
      componentName: "Bank",
      method: "backend",
      type: "bank",
      selectName: "Pay with Bank Account",
      selectTitle: "Bank Account",
      ico: "icon-Icon_Bankacc_nor_48"
    },
    {
      tabName: "Bank Acc.",
      componentName: "Bank",
      method: "inline",
      type: "bank",
      selectName: "Pay with Bank Account",
      selectTitle: "Bank Account",
      ico: "icon-Icon_Bankacc_nor_48"
    },
    {
      tabName: "Bank Acc.",
      componentName: "Bank",
      method: "standard",
      type: "bank",
      selectName: "Pay with Bank Account",
      selectTitle: "Bank Account",
      ico: "icon-Icon_Bankacc_nor_48"
    },
    // ussd
    {
      tabName: "USSD",
      componentName: "USSD",
      method: "backend",
      type: "ussd",
      selectName: "Pay by dailing USSD Code",
      selectTitle: "USSD Code",
      ico: "icon-Icon_Ussd_nor_481"
    },
    {
      tabName: "USSD",
      componentName: "USSD",
      method: "inline",
      type: "ussd",
      selectName: "Pay by dailing USSD Code",
      selectTitle: "USSD Code",
      ico: "icon-Icon_Ussd_nor_481"
    },
    {
      tabName: "USSD",
      componentName: "USSD",
      method: "standard",
      type: "ussd",
      selectName: "Pay by dailing USSD Code",
      selectTitle: "USSD Code",
      ico: "icon-Icon_Ussd_nor_481"
    },
    // opay
    {
      tabName: "OPay Web",
      componentName: "OPayAppCont",
      method: "h5",
      type: "opay",
      selectName: "Pay via OPay Web",
      selectTitle: "OPay Web",
      ico: "icon-Icon_Opayonline_nor_48"
    },
    {
      tabName: "OPay",
      componentName: "OPayApp",
      method: "app",
      type: "opay",
      selectName: "Pay via OPay App",
      selectTitle: "OPay App",
      ico: "icon-Icon_Opayonline_nor_48"
    },
    // palm
    {
      tabName: "PalmPay",
      componentName: "PalmPay",
      method: "h5",
      type: "palm",
      selectName: "Pay via PalmPay",
      selectTitle: "PalmPay",
      ico: "icon-Icon_Palmpay_nor_48"
    },
    // qr
    {
      tabName: "QR",
      componentName: "QR",
      method: "backend",
      type: "qr",
      selectName: "Pay by scanning QR Code",
      selectTitle: "QR Code",
      ico: "icon-Icon_Qr_nor"
    },
    // atm
    {
      tabName: "ATM Deposit",
      componentName: "ATMDeposite",
      method: "h5",
      type: "atm",
      selectName: "Pay via ATM Deposit",
      selectTitle: "ATM Deposit",
      ico: "icon-Icon_Atmdep_nor_48"
    },
    // flutterwave
    {
      tabName: "Flutter wave",
      componentName: "Futter",
      method: "inline",
      type: "flutterwave",
      selectName: "Pay via Flutterwave",
      selectTitle: "Flutterwave",
      ico: "icon-Icon_Flutterwave_nor_48"
    },
    // bank transfer
    {
      tabName: "Bank Transfer",
      componentName: "BankTransfer",
      method: "h5",
      type: "bank transfer",
      selectName: "Pay via Bank Transfer",
      selectTitle: "Bank Transfer",
      ico: "icon-Icon_BankTransfer_nor_48"
    },
    // instant transfer
    {
      tabName: "Instant Transfer",
      componentName: "InstantTransfer",
      method: "h5",
      type: "instant transfer",
      selectName: "Pay via Instant Transfer",
      selectTitle: "Instant Transfer",
      ico: "icon-Icon_InstantTransfer_nor_48"
    },
    // paga
    {
      tabName: "Paga",
      componentName: "Paga",
      method: "app",
      type: "paga",
      selectName: "Pay via Paga",
      selectTitle: "Paga",
      ico: "icon-Icon_Paga_nor48_48"
    },
    // quicktell
    {
      tabName: "Quick teller",
      componentName: "Quickteller",
      method: "h5",
      type: "quicktell",
      selectName: "Pay via Quickteller",
      selectTitle: "Quickteller",
      ico: "icon-Icon_Quickteller_nor_48"
    },
    {
      tabName: 'Monnify',
      componentName: 'Monnify',
      method: 'h5',
      type: 'monnify',
      selectName: 'Pay via Monnifyer',
      selectTitle: 'Monnifyer',
      ico:"icon-Icon_Monnify_nor_48"
    }
  ],

  AMOUNT_LIST: {
    ke: [
      { amount: 48, discount: 0 },
      { amount: 98, discount: 0 },
      { amount: 477, discount: 0 },
      { amount: 977, discount: 0 },
      { amount: 150000, discount: 0 }
    ],
    ng: [
      { amount: 100, discount: 0 },
      { amount: 200, discount: 0 },
      { amount: 500, discount: 0 },
      { amount: 1000, discount: 0 },
      { amount: 5000, discount: 0 }
    ],
    ug: [
      { amount: 2000, discount: 0 },
      { amount: 4000, discount: 0 },
      { amount: 8000, discount: 0 },
      { amount: 10000, discount: 0 },
      { amount: 50000, discount: 0 }
    ],
    gh: [
      { amount: 1, discount: 0 },
      { amount: 5, discount: 0 },
      { amount: 20, discount: 0 },
      { amount: 50, discount: 0 },
      { amount: 100, discount: 0 }
    ],
    tz: [
      { amount: 500, discount: 0 },
      { amount: 1000, discount: 0 },
      { amount: 2000, discount: 0 },
      { amount: 5000, discount: 0 },
      { amount: 10000, discount: 0 }
    ]
  },

  INTRODUCE_LIST: {
    ng: {
      head: "Expand query common feedback",
      list: [
        {
          application: "h5",
          content:
            "<p>1. The top-up amount must be used to bet first, otherwise a withdrawal fee shall be charged. All money won using our bonuses shall be free to withdraw.<br />2. The minimum deposit amount is NGN 100.<br />3. The maximum deposit amount is NGN 9,999,999.<br />4. Trying to use multiple cards/bank accounts for multiple deposits may cause error.<br />5. If you cannot receive the bank&rsquo;s OTP for a long time, please try again later.<br />6. If you failed to deposit, we suggest retrying with other payment methods, or contact our customer service.<br />7. For your fund security, only if the holder's name of your bank account and BVN match can you withdraw successfully.<br />8. Banks may charge Deposit fees and VAT.</p>",
          country: "ng",
          title: "Tips"
        },
        {
          application: "h5",
          content:
            "<p>Please read the failure prompt carefully, most users experience this issue as a result of insufficient bank card balance or entered an incorrect OTP. please try to pay again. In addition, we suggest that you use bank transfer for payment.</p></p>",
          country: "ng",
          title: "Payment with bank card failed"
        },
        {
          application: "h5",
          content:
            "<p>Please read the failure prompt carefully, most users experience this issue as a result of insufficient bank account balance or entered an incorrect OTP. please try to pay again. In addition, we suggest that you use bank transfer for payment.</p>",
          country: "ng",
          title: "Payment with bank accounts failed"
        }
      ]
    },

    gh: {
      head: "Need to pay for help.",
      list: [
        {
          application: "h5",
          content:
            "<p>1. Minimum per transaction is GHS 1.00.<br />2. Maximum per transaction is GHS 100,000.00.<br /> 3. Your balance can only be withdrawn to the mobile number that you registered with.<br />4. The top-up amount must be used to bet first, otherwise a withdrawal fee shall be charged. All money won using our bonuses shall be free to withdraw.</p>",
          country: "gh",
          title: "Tips"
        }
      ]
    },

    ke: {
      head: "Other payment method and help.",
      list: [
        {
          application: "h5",
          content:
            "<p>1: Go to M-PESA menu on your mobile phone<br />2: Select Lipa na M-PESA<br />3: Select Pay Bill<br />4: Enter 569699 as Business Number<br />5: Enter Bangbet as reference Number<br />6: Enter amount(NO COMMAS) e.g 100<br />7: Enter your M-PESA PIN and send<br />8: You will receive an SMS confirming the transaction</p>",
          country: "ke",
          title: "Pay with M-PESA Paybill 569699"
        },
        {
          application: "h5",
          content:
            "<p>1: Go to Airtel SIM tool kit menu on your mobile phone<br />2: Select Airtel money<br />3: Select Make Payments<br />4: Select Paybill choose Other<br />5: Enter Bangbet as the Business Name<br />6: Input the reference as Bangbet<br />7: Enter the amount and your PIN<br />8: You will receive an SMS confirming the transaction</p>",
          country: "ke",
          title: "Pay with Airtel Paybill"
        },
        {
          application: "h5",
          content:
            "<p>1. M-PESA:<br />Deposite 48 Refund 2<br />Deposite 98 Refund 2<br />Deposite 250&#65374;999 Refund 23<br />Deposite 1,000&#65374;2,499 Refund 34<br />Deposite 2,500&#65374;4,999 Refund 56<br />Deposite 5,000&#65374;9,999 Refund 85<br />Deposite 10,000&#65374;34,999 Refund 112<br />Deposite 35,000&#65374;49,999 Refund 202<br />Deposite 50,000+ Refund 210</p><p>2. Airtel:<br />Deposite 48 Refund 2<br />Deposite 98 Refund 2<br />Deposite 250&#65374;1,000 Refund 18<br />Deposite 1,001&#65374;2,500 Refund 27<br />Deposite 2,501&#65374;5,000 Refund 44<br />Deposite 5,001&#65374;10,000 Refund 65<br />Deposite 10,001&#65374;35,000 Refund 85<br />Deposite 35,001&#65374;50,000 Refund 150<br />Deposite 50,001+ Refund 160</p>",
          country: "ke",
          title: "Extra&Receive"
        },
        {
          application: "h5",
          content:
            "<p>M-PESA MANUAL RECONCILIATION</p><p>Please copy and paste the M-Pesa Transaction Code which was sent to your Mobile Phone via SMS to manually deposit your cash into your BangBet account, e.g MDI3WSXXXX</p><p>M-Pesa Manual Reconciliation is used in situations such as.</p><p>When one receives the M-Pesa SMS informing them that the transaction was successful, yet it failed due to the situations listed below:</p><p>1. Deposit is displayed as Failed.<br />2. Deposit is displayed as Pending.<br />3. Made deposit through our M-Pesa Paybill(569699), but the cash never reflected in the BangBet account.</p><p>You can fix all these issues by using this function by just pasting the M-pesa Transaction Code above and clicking CONFIRM. The Cash will instantly be added to your BangBet account.</p>",
          country: "ke",
          title: "Deposit Unsuccessful"
        },
        {
          application: "h5",
          content:
            "<p>1. Maximum Daily Transcation Value is KSH 300,000.00<br />2. Maximum per transaction is KSH 150,000.00<br />3. Deposit an amount between KSH 1~150,000 from your M-pesa account to your bangbet account. All safaricom M-pesa charges incurred on all qualifying deposits as indicated above will automatically be credited on top of your initial deposit.</p>",
          country: "ke",
          title: "Tips"
        }
      ]
    },

    ug: {
      head: "Need to pay for help.",
      list: [
        {
          application: "h5",
          content:
            "<p>1. Minimum per transaction is USH 600.<br />2. Maximum per transaction is USH 400,000.00.<br />3. Your balance can only be withdrawn to the mobile number that you registered with.<br />4. The top-up amount must be used to bet first, otherwise a withdrawal fee shall be charged. All money won using our bonuses shall be free to withdraw.</p>",
          country: "ug",
          title: "Tips"
        }
      ]
    },
    // 多语言文件在这里加载有异步问题，翻译文案直接写在这
    tz: {
      head: "",
      list: [
        {
          title: "HOW TO DEPOSIT TO YOUR BANGBET ACCOUNT",
          country: "tz",
          content: "<p>Once you've finished signing up, deposit money into your Bangbet account. It's easy, just follow the steps below depending on the network you use:</p>",
          application: "h5"
        },
        {
          title: "VODACOM",
          country: "tz",
          content: "<p>Dial *150*00#<br />Choose number 4 (Pay the Bill).<br />Select 4 then enter the company number (504050)<br />Record the number (123)<br />Enter the amount (minimum of TZS 500)<br />Enter your PIN and then press 1 to confirm<br />You will receive a message confirming your transaction.</p>",
          application: "h5"
        },
        {
          title: "TIGO",
          country: "tz",
          content: "<p>Dial *150*01#<br />Choose number 4 (Pay the Bill)<br />Select 3 then enter the company number (504050)<br />Enter Reference Number (123)<br />Enter the amount (minimum of TZS 500)<br />Enter your PIN and press 1 to confirm<br />You will receive a message confirming your transaction.</p>",
          application: "h5"
        },
        {
          title: "HALOTEL",
          country: "tz",
          content: "<p>Dial *150*88#<br />Choose number 4 (Pay the Bill)<br />Select 3 then enter the company number (504050)<br />Enter Reference Number (123)<br />Enter the amount of money you need (minimum of TZS 500)<br />Enter the password and then press 1 to confirm<br />You will receive a message confirming your transaction.</p>",
          application: "h5"
        },
        {
          title: "AIRTEL",
          country: "tz",
          content: "<p>Dial *150*60#<br />Choose number 5 (Pay the Bill)<br />Choose number 6 (Gaming and Betting)<br />Choose number 1 (Betting)<br />Choose number 39 (BANGBET)<br />Enter Reference Number (123)<br />Enter the amount of money you need (minimum of TZS 500)<br />Enter the PIN then Submit<br />You will receive a message confirming your transaction.</p>",
          application: "h5"
        }
      ]
    },
    "tz-sw": {
      head: "",
      list: [
        {
          title: "JINSI YA KUWEKA PESA KWENYE AKAUNTI YAKO YA BANGBET",
          country: "tz",
          content: "<p>Baada ya kumaliza kujiandikisha, weka pesa kwenye akaunti yako ya Bangbet. Ni rahisi, fuata hatua zifuatazo kulingana na mtandao unaoutumia:</p>",
          application: "h5"
        },
        {
          title: "VODACOM",
          country: "tz",
          content: "<p>Piga *150*00#<br />Chagua namba 4 (Lipa Bili).<br />Chagua 4 kisha ingiza namba ya kampuni (504050)<br />Ingiza Namba ya Kumbukumbu (123)<br />Ingiza kiasi (kiwango cha chini cha TZS 500)<br />Ingiza PIN yako na kisha bonyeza 1 kuthibitisha<br />Utapokea ujumbe ukithibitisha muamala wako.</p>",
          application: "h5"
        },
        {
          title: "TIGO",
          country: "tz",
          content: "<p>Piga *150*01#<br />Chagua namba 4 (Lipa Bili)<br />Chagua 3 kisha ingiza namba ya kampuni (504050)<br />Ingiza Namba ya Kumbukumbu (123)<br />Ingiza kiasi (kiwango cha chini cha TZS 500)<br />Ingiza PIN yako na bonyeza 1 kuthibitisha<br />Utapokea ujumbe ukithibitisha muamala wako.</p>",
          application: "h5"
        },
        {
          title: "HALOTEL",
          country: "tz",
          content: "<p>Piga *150*88#<br />Chagua namba 4 (Lipa Bili)<br />Chagua 3 kisha ingiza namba ya kampuni (504050)<br />Ingiza Namba ya Kumbukumbu (123)<br />Ingiza kiasi cha pesa unachohitaji (kiwango cha chini cha TZS 500)<br />Ingiza nywila na kisha bonyeza 1 kuthibitisha<br />Utapokea ujumbe ukithibitisha muamala wako.</p>",
          application: "h5"
        },
        {
          title: "AIRTEL",
          country: "tz",
          content: "<p>Piga *150*60#<br />Chagua namba 5 (Lipa Bili)<br />Chagua namba 6 (Gaming and Betting)<br />Chagua namba 1 (Betting)<br />Chagua namba 39 (BANGBET)<br />Ingiza Namba ya Kumbukumbu (123)<br />Ingiza kiasi cha pesa unachohitaji (kiwango cha chini cha TZS 500)<br />Ingiza PIN kisha Wasilisha<br />Utapokea ujumbe ukithibitisha muamala wako.</p>",
          application: "h5"
        }
      ]
    },
  },

  KE_TABLIST: [
    {
      tabName: "M-PESA",
      type: "mpesa",
      ico: "icon-Icon_MPESApaybill_48"
    },
    {
      tabName: "Airtel",
      type: "airtel",
      ico: "icon-Icon_Pay_Airtel_48"
    },
    {
      tabName: "Airtel",
      type: "oldairtel",
      ico: "icon-Icon_Pay_Airtel_48"
    }
  ],
  UG_TABLIST: [
    {
      tabName: "MTN",
      type: "mtn",
      ico: "icon-Icon_Mtn_48"
    },
    {
      tabName: "Airtel",
      type: "airtel",
      ico: "icon-Icon_Pay_Airtel_48"
    },
    {
      tabName: "YoPay",
      type: "yopayment",
      ico: "icon-a-Icon_YoPayments_nor_48"
    },
    {
      tabName: "MTN",
      type: "yoMtn",
      ico: "icon-Icon_Mtn_48"
    },
    {
      tabName: "Airtel",
      type: "yoAirtel",
      ico: "icon-Icon_Pay_Airtel_48"
    }
  ],
  GH_TABLIST: [
    {
      tabName: "MTN",
      type: "mtn",
      ico: "icon-Icon_Mtn_48"
    },
    {
      tabName: "Tigo",
      type: "tigo",
      ico: "icon-Icon_Tigo_48"
    },

    {
      tabName: "Vodafone",
      type: "vodafone",
      ico: "icon-Icon_Vodafone_48"
    }
  ],
  NG_TABLIST: [
    {
      tabName: "Bank",
      type: "bank",
      ico: "icon-Icon_Bankacc_nor_48"
    },
    {
      tabName: "OPay",
      type: "opay",
      ico: "icon-Icon_Opayonline_nor_48"
    },
    {
      tabName: "PalmPay",
      type: "palmpay",
      ico: "icon-Icon_Palmpay_nor_48"
    }
  ],
  WITHDRAW_TIPLIST: {
    ke: {
      head: "Expand query common feedback",
      list: [
        {
          application: "h5",
          content:
            "<p>1. The minimum withdraw is KSH 100.<br/> 2. The maximum withdraw is KSH 150,000.<br/> 3. Please note that Mpesa additional carrier fees of KSH 15 apply when processing withdrawal requests.</p>",
          country: "ke",
          title: "M-PESA Tips"
        },
        {
          application: "h5",
          content:
            "<p>1. The minimum withdraw is KSH 100.<br/> 2. The maximum withdraw is KSH 150,000.<br/> 3. 3. Three free withdrawals per day for amounts above KSH 500.<br/>4. Withdrawal service charge:<br/>Amount 100~1000, Service charge KSH 11<br/> Amount 1001~3000, Service charge KSH 23<br/> Amount 3001~7000, Service charge KSH 32</p>",
          country: "ke",
          title: "Airtel Tips"
        },
        {
          application: "h5",
          content:
            "<p>If your withdrawal order status is pending , we advise you to wait patiently, as it normally takes the mobile money within 24 hours to process the transaction.</p>",
          country: "ke",
          title: "Withdrawal status 'pending'"
        }
      ]
    },
    ug: {
      head: "Expand query common feedback",
      list: [
        {
          application: "h5",
          content:
            "<p>1. Minimum per transaction is USH 1000.<br/> 2. Maximum per transaction is USH 500,000<br/> 3. Your mobile money service may charge a withdraw fee of (UGX 300 Airtel) or (UGX 390 MTN)</p>",
          country: "ug",
          title: "Tips"
        },
        {
          application: "h5",
          content:
            "<p>If your withdrawal order status is pending , we advise you to wait patiently, as it normally takes the mobile money within 24 hours to process the transaction.",
          country: "ug",
          title: "Withdrawal status 'pending'"
        }
      ]
    },
    ng: {
      head: "Expand query common feedback",
      list: [
        {
          application: "h5",
          content:
            "<p>1. A single withdrawal amount must be from NGN100 and NGN100000. Please make sure that your balance and withdrawal amount are within the requirements.<br/> 2. Transfers ess than NGN 5,000 will now cost NGN 10. transfers between NGN 5,000 and NGN 50,000 will now cost NGN 25. transfers equal to or greater than NGN 50,000 will now cost NGN 50.</p>",
          country: "ng",
          title: "Withdrawal amount"
        },
        {
          application: "h5",
          content:
            "<p>Every amount recharged must be used to place bet before it can be withdrawn. If you wish to withdraw an amount that has not been used to place bet, a 1.5% commission will be charged for the withdrawal.</p>",
          country: "ng",
          title: "Withdrawal service charge"
        },
        {
          application: "h5",
          content:
            "<p>If your withdrawal order status is pending , we advise you to wait patiently, as it normally takes the Bank within 24 hours to process the transaction.</p>",
          country: "ng",
          title: "Withdrawal status 'pending'"
        },
        {
          application: "h5",
          content:
            "<p>According to Nigerian laws and regulations, you are required to submit KYC information before withdrawal. We only allow withdrawal to a bank account with a unique name. please note that your name cannot be changed after approval and we will make sure to keep your information confidential.</p>",
          country: "ng",
          title: "Compliance policy requirements"
        }
      ]
    },
    gh: {
      head: "Expand query common feedback",
      list: [
        {
          application: "h5",
          content:
            "<p>1. Minimum per transaction is GHS 1.00.<br/> 2. Maximum per transaction is GHS 30,000.00.<br/> 3. There are 3 free withdrawals each day of which 1% transaction fee will be charged for exceeding the limit.<br/>4. The top-up amount must be used to bet first, otherwise a withdrawal fee shall be charged. All money won using our bonuses shall be free to withdraw.</p>",
          country: "gh",
          title: "Tips"
        },
        {
          application: "h5",
          content:
            "<p>If your withdrawal order status is pending , we advise you to wait patiently, as it normally takes the mobile money within 24 hours to process the transaction.</p>",
          country: "gh",
          title: "Withdrawal status 'pending'"
        }
      ]
    },
    tz: {
      head: "Panua hoja ya maoni ya kawaida",
      list: [
        {
          title: "Vidokezo",
          application: "h5",
          content: `<p>1. Kiwango cha chini kwa kila muamala ni TZS 1000.00<br>2. Kiwango cha juu kwa kila muamala ni TZS 5,000,000.<br>3. Kuna uondoaji 3 bila malipo kila siku ambapo 1% ya ada ya muamala itatozwa kwa kuzidi kikomo.<br>4. Kiasi cha nyongeza lazima kitumike kubashiri kwanza, vinginevyo ada ya kujitoa itatozwa. Pesa zote zilizoshinda kutumia bonasi zetu zitakuwa huru kutoa. Hali ya kutoa pesa "inaendelea"Hali ya uondoaji "inasubiri"  Ikiwa hali ya agizo lako la uondoaji inasubiri , tunakushauri usubiri kwa subira, kwani kwa kawaida huchukua pesa za simu ndani ya masaa 24 ili kushughulikia muamala. Huduma kwa mteja 24/7</p>`,
          country: "tz"
        }
      ]
    }
  }
};
export default CONSTS_CONFIG;



// WEBPACK FOOTER //
// ./src/baseConfig/consts.js